import { Link, useNavigate } from "react-router-dom";

import { AnnulmentIcon } from "@components/titleAnnulments/AnnulmentIndicator";
import { compactCents } from "../../utils/directorFormat";

// Nas telas da Diretoria (Capital, Recebíveis e compromissos), o aviso é o mesmo indicador do
// Ampli Obras: ícone ao lado dos valores, com a contagem e quanto saiu de "a pagar" e de "a
// receber" no tooltip. Clicar no ícone ou em "Ver lista" leva à lista de Governança, que é
// onde a Diretoria edita os títulos anulados (a barra lateral do Ampli Obras é por obra).
export const excludedTitlesText = (summary) => {
  const head = `${summary.count === 1 ? "1 título anulado" : `${summary.count} títulos anulados`} na Ampli fora deste valor`;
  return [
    head,
    summary.outflowCents > 0 ? `A pagar: ${compactCents(summary.outflowCents)}` : null,
    summary.inflowCents > 0 ? `A receber: ${compactCents(summary.inflowCents)}` : null,
  ].filter(Boolean).join(" · ");
};

const ExcludedTitlesNotice = ({ summary, companyId }) => {
  const navigate = useNavigate();
  if (!summary?.count) return null;
  const query = companyId ? `?company_id=${encodeURIComponent(companyId)}` : "";
  const target = `/dashboard/director/governance${query}`;
  return <div className="director-module1__callout director-excluded-titles" role="note" aria-label="Títulos anulados na Ampli">
    <AnnulmentIcon message={excludedTitlesText(summary)} onClick={() => navigate(target)} />
    {" "}<Link to={target}>Ver lista</Link>
  </div>;
};

export default ExcludedTitlesNotice;
